import tableVodTemplate from './tableVodTemplate';

export default {
  title: 'VoD Templates',
  attributeName: 'vodTemplates',
  getURL: 'vodTemplates',
  updateURL: 'vodTemplates',
  removeURL: 'vodTemplates',
  sessionParams: [],
  noArea: true,
  tableConfig: tableVodTemplate,
  autoUpdate: false,
};